<script setup>

const props = defineProps({
  menu: {
    type: Array,
  }
})

const menuStyle = ref({
	transform: 'translateY(15%)',
	opacity: 0,
})


const getColor = (title) => {
	switch (title) {
		case 'SUPRAPHON podcast':
			return 'cyan'
		case 'PLATFORMA Academy':
			return 'magenta'
		default:
			return "red"
	}
}

const emit = defineEmits(['reset', 'updateSection'])

onMounted(() => {
	setTimeout(() => {
		menuStyle.value = {
			transform: 'translateY(0)',
			opacity: 1,
		}
	}, 200)
})


</script>

<template>
	<div
		class="container color-menu"
		:style="{
			opacity: menuStyle.opacity,
			transform: menuStyle.transform,
		}"
	>
		<div class="flex flex-wrap">
			<div v-for="(item, index) in menu" :key="index">
				<a
					href="#"
					@click.prevent="item.type === 'Podcasts' ? emit('reset') : emit('updateSection')"
					class="mr-2 md:mr-3 lg:mr-5 leading-none fvs600 text-[43px] tracking-[-0.645px]"
					:class="`text-${item.type === 'Podcasts' ? 'green' : getColor(item.title)}`"
				>
					{{ item.label || item.title }}
				</a>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.color-menu {
	transition: 0.7s ease-out;
}
</style>